import { API_URL_AWARD } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getAwards = () =>
  apiInstance({
    url: API_URL_AWARD,
    params: {
      limit: 5000,
      sort: "year",
      order: -1,
    },
  });

export default getAwards;
